"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainflexFinderLocaleConfig = exports.iaConfiguratorLocaleConfig = exports.expertLocaleConfig = exports.iQuoteLocaleConfig = void 0;
/**
 * The `LocaleConfig` for iQuote
 */
exports.iQuoteLocaleConfig = {
    defaultUserLanguageTag: 'en',
    defaultArticleLanguageTags: ['en-GB', 'en-US', 'de-DE'],
    defaultCadClickLanguageTag: 'en-GB',
    availableArticleLanguageTags: [
        'bg-BG',
        'cs-CZ',
        'da-DK',
        'de-DE',
        'en-GB',
        'en-US',
        'es-ES',
        'fr-FR',
        'hu-HU',
        'id-ID',
        'it-IT',
        'ja-JP',
        'ko-KR',
        'nl-NL',
        'pl-PL',
        'pt-PT',
        'pt-BR',
        'ro-RO',
        'ru-RU',
        'sv-SE',
        'tr-TR',
        'zh-CN',
        'zh-TW',
    ],
    missingTranslationValue: 'n/a',
};
/**
 * The `LocaleConfig` for Expert
 */
exports.expertLocaleConfig = {
    defaultUserLanguageTag: 'en',
    defaultArticleLanguageTags: ['en-GB', 'en-US', 'de-DE'],
    defaultCadClickLanguageTag: 'en-GB',
    availableArticleLanguageTags: [
        'bg-BG',
        'cs-CZ',
        'da-DK',
        'de-DE',
        'en-GB',
        'en-US',
        'es-ES',
        'fr-FR',
        'hu-HU',
        'id-ID',
        'it-IT',
        'ja-JP',
        'ko-KR',
        'nl-NL',
        'pl-PL',
        'pt-PT',
        'pt-BR',
        'ro-RO',
        'ru-RU',
        'sv-SE',
        'tr-TR',
        'zh-CN',
        'zh-TW',
    ],
    missingTranslationValue: 'n/a',
};
/**
 * The `LocaleConfig` for Ia Configurator
 */
exports.iaConfiguratorLocaleConfig = exports.expertLocaleConfig;
/**
 * The `LocaleConfig` for Chainflex Finder
 */
exports.chainflexFinderLocaleConfig = exports.expertLocaleConfig;
//# sourceMappingURL=LocaleConfig.js.map